import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IOffer } from '@rbi-ctg/menu';
import { OfferCell } from 'components/offer/ui-refresh/cell';
import { ClearSelectedOffer } from 'state/offers/hooks/types';

import { BG, BTN_FONT, BTN_FONT_WEIGHT, BTN_TEXT_DECORATION, COLOR, FONT } from './constants';

interface IOfferSelectedProps {
  offer: IOffer;
  onRemoveSelectedOffer: ClearSelectedOffer;
  onClick: (offerId: string) => void;
  isSelected: boolean;
  favoriteEnabled?: boolean;
  favorited?: boolean;
  handleToggleFavorite?: (sanityId: string, name: string) => void;
}

const Container = styled.div`
  background: ${BG};
  padding: 5px;
`;
const SelectedOffer = styled(OfferCell)`
  list-style: none;
`;
const OfferSelectedHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  color: ${COLOR};
  font-family: ${FONT};
`;
const Text = styled.p`
  font-size: 0.875rem;
  line-height: 18px;
`;
const RemoveButton = styled.a`
  font-family: ${BTN_FONT};
  line-height: 14px;
  font-weight: ${BTN_FONT_WEIGHT};
  text-decoration: ${BTN_TEXT_DECORATION};
  cursor: pointer;
`;

const OfferSelected: React.FC<IOfferSelectedProps> = ({
  offer,
  onRemoveSelectedOffer,
  isSelected,
  onClick,
  favoriteEnabled,
  favorited,
  handleToggleFavorite,
}) => {
  const { formatMessage } = useIntl();
  const removeOffer = () => {
    onRemoveSelectedOffer();
  };
  return (
    <Container data-testid="offer-selected-container">
      <OfferSelectedHeader>
        <Text>{formatMessage({ id: 'offerSelected' })}</Text>
        <RemoveButton data-testid="offer-selected-remove-btn" onClick={removeOffer}>
          {formatMessage({ id: 'remove' })}
        </RemoveButton>
      </OfferSelectedHeader>
      <SelectedOffer
        offer={offer}
        isSelected={isSelected}
        offerFeedback={null}
        onClick={onClick}
        favoriteEnabled={favoriteEnabled}
        favorited={favorited}
        handleToggleFavorite={handleToggleFavorite}
      />
    </Container>
  );
};

export default OfferSelected;
